/* eslint-disable eqeqeq */
import React, { Component, Fragment, useState, useEffect, useMemo, useRef } from 'react';
import { Checkbox } from '@rmwc/checkbox';
import { Select } from '@rmwc/select';
import { TextField } from '@rmwc/textfield';
import Draggable from 'react-draggable';
import CurrencyFormat from 'react-currency-format';
import { useDispatch,useSelector } from 'react-redux';

import EditPriceItem from '../../EditPriceItem/EditPriceItem';

import { const_var, params } from '../../../redux/reducers/reducer'
import * as actionCreator from "../../../action/index.js";
import { isCheckCustomSizeInRange } from  '../../../redux/reducers/utils';
import { Radio } from '@rmwc/radio';
import Slider from "react-slick";
import AnimButton from '../../Button/AnimButton.js';
import { addValidation } from '../../../utils/Validation.js';

const DoorWindowEditBox = () => {
    const dispatch = useDispatch();
    const state = useSelector((state)=>state.priceUpdateReducer)
    const doorUniqueId = const_var.doorUniqueId;
    let DoorVar = const_var.exactDoorType;
    let commonDoorType = const_var.commonDoorType;    
    let DoorObjData = '';
    let wallCheckForEnd = false;
    let wallCheckForSide = false;
    let exactComName = "";
    let doorColorData = '';    
    let maxWidth1 = '';
    let maxHeight1 = '';
    let minWidth1 = '';
    let minHeight1 = '';
    let showCustomSize = 'none'
    // const state = useSelector((state)=>state.priceUpdateReducer)
    //let priceData = useMemo(() => { return const_var.entry_points.filter(entry_points => entry_points.uniqueId == doorUniqueId);}, [doorUniqueId])

    let priceData = const_var.entry_points.filter(entry_points => entry_points.uniqueId == doorUniqueId);  /* [] // */

      let EntrynotesData = "";
    if(const_var.post_data.building!=undefined && priceData.length>0 && priceData[0].entry_note!='')
    {
        EntrynotesData = priceData[0].entry_note!=null?priceData[0].entry_note:'';
    }else
    {
        EntrynotesData = params.extra_notes!=null?params.extra_notes:'';
    }
    let findIndex = useMemo(() => { return const_var.newDoorsArray.findIndex(entry_points => entry_points.uniqueId == doorUniqueId);}, [doorUniqueId])
    // let sourceEntryNoteData = useMemo(() => {
    //     if (const_var.newDoorsArray.length > 0) return const_var.newDoorsArray.find(s => s.uniqueId === doorUniqueId).entryNoteData
    //     else return ''
    // }, [const_var.doorUniqueId])

    const [isTextField, setIsTextField] = useState(false)
    const [activeDrags, setActiveDrags] = useState(0);
    const [controlledPosition, setControlledPosition] = useState({x: 0, y: 0});
    // const [entryNoteDataValue, setEntryNoteDataValue] = useState('')

    if (priceData.length > 0) {
        const componentType = const_var.newComponentArray[priceData[0].parent_array_key].find(item => item.type == priceData[0].child_array_key && item.alias_name == priceData[0].nested_array_key);
        if (componentType) {
            DoorObjData = componentType.sizes.find(item => item.fixed_sizes?.[0]?.width == priceData[0].entry_dimension_width && item.fixed_sizes?.[0]?.height == priceData[0].entry_dimension_height);
        }
        if(DoorObjData==undefined)
        {
            DoorObjData = const_var.newCustomSizesArray;
        }
        // doorColorData = const_var.newComponentArray[priceData[0].parent_array_key][priceData[0].child_array_key][priceData[0].nested_array_key]['garageDoorColor'];
        

        if(priceData[0].parent_array_key === "Walk" || priceData[0].parent_array_key === "Walk_Frameout"){
            if(const_var.c_m_a[params.p_b_t].custom_size_status && priceData[0].parent_array_key === "Walk" && const_var.c_m_a[params.p_b_t].custom_size_status.show_walk_in_door != undefined){
                showCustomSize = const_var.c_m_a[params.p_b_t].custom_size_status.show_walk_in_door == true ? 'show' : const_var.c_m_a[params.p_b_t].custom_size_status.show_walk_in_door == false ? 'hide' : 'none'
            }
            if(const_var.c_m_a[params.p_b_t].custom_size_status && priceData[0].parent_array_key === "Walk_Frameout" && const_var.c_m_a[params.p_b_t].custom_size_status.show_walk_in_door_frameout != undefined){
                showCustomSize = const_var.c_m_a[params.p_b_t].custom_size_status.show_walk_in_door_frameout == true ? 'show' : const_var.c_m_a[params.p_b_t].custom_size_status.show_walk_in_door_frameout == false ? 'hide' : 'none'
            }            

            if(showCustomSize == 'show' && const_var.c_m_a[params.p_b_t].custom_size_status && const_var.newComponentArray[priceData[0].parent_array_key][priceData[0].child_array_key][priceData[0].nested_array_key]['CustomSize'] /* && const_var.newComponentArray[priceData[0].parent_array_key][priceData[0].child_array_key][priceData[0].nested_array_key]['CustomSize'].length != 0 */){
                if(const_var.newComponentArray[priceData[0].parent_array_key][priceData[0].child_array_key][priceData[0].nested_array_key]['CustomSize'].length != 0){
                    // ################### code to manage custom size dropdown from api ###################
                    let dataRangeWidth = isCheckCustomSizeInRange(priceData[0].parent_array_key,const_var.newComponentArray[priceData[0].parent_array_key][priceData[0].child_array_key][priceData[0].nested_array_key]['CustomSize'],'','','width');
                    let dataRangeHeight = isCheckCustomSizeInRange(priceData[0].parent_array_key,const_var.newComponentArray[priceData[0].parent_array_key][priceData[0].child_array_key][priceData[0].nested_array_key]['CustomSize'],'','','height');
                    
                    maxWidth1 = dataRangeWidth.split('-')[1]
                    maxHeight1 = dataRangeHeight.split('-')[1]
                    minWidth1 = dataRangeWidth.split('-')[0]
                    minHeight1 = dataRangeHeight.split('-')[0]
                }
                else{
                    // if(const_var.crmSetting.is_Edit == true && priceData[0].entry_doorNewType == "Custom Size"){
                        showCustomSize = 'none'
                        maxWidth1 = 72;
                        maxHeight1 = 84;
                        minWidth1 = 24;
                        minHeight1 = 60;
                    // }
                    // else{
                    //     showCustomSize = 'hide'
                    // }
                }
            }
            else{
                if(showCustomSize == 'none'){
                    maxWidth1 = 72;
                    maxHeight1 = 84;
                    minWidth1 = 24;
                    minHeight1 = 60;
                }
            }
        } else if(priceData[0].parent_array_key ==="Windows" || priceData[0].parent_array_key === "Windows_Frameout"){
            if(const_var.c_m_a[params.p_b_t].custom_size_status && priceData[0].parent_array_key === "Windows" && const_var.c_m_a[params.p_b_t].custom_size_status.show_window != undefined){
                showCustomSize = const_var.c_m_a[params.p_b_t].custom_size_status.show_window == true ? 'show' : const_var.c_m_a[params.p_b_t].custom_size_status.show_window == false ? 'hide' : 'none'
            }
            if(const_var.c_m_a[params.p_b_t].custom_size_status && priceData[0].parent_array_key === "Windows_Frameout" && const_var.c_m_a[params.p_b_t].custom_size_status.show_window_frameout != undefined){
                showCustomSize = const_var.c_m_a[params.p_b_t].custom_size_status.show_window_frameout == true ? 'show' : const_var.c_m_a[params.p_b_t].custom_size_status.show_window_frameout == false ? 'hide' : 'none'
            }
            if(showCustomSize == 'show' && const_var.c_m_a[params.p_b_t].custom_size_status && const_var.newComponentArray[priceData[0].parent_array_key][priceData[0].child_array_key][priceData[0].nested_array_key]['CustomSize'] /* && const_var.newComponentArray[priceData[0].parent_array_key][priceData[0].child_array_key][priceData[0].nested_array_key]['CustomSize'].length != 0 */){
                if(const_var.newComponentArray[priceData[0].parent_array_key][priceData[0].child_array_key][priceData[0].nested_array_key]['CustomSize'].length != 0){
                    // ################### code to manage custom size dropdown from api ###################
                    let dataRangeWidth = isCheckCustomSizeInRange(priceData[0].parent_array_key,const_var.newComponentArray[priceData[0].parent_array_key][priceData[0].child_array_key][priceData[0].nested_array_key]['CustomSize'],'','','width');
                    let dataRangeHeight = isCheckCustomSizeInRange(priceData[0].parent_array_key,const_var.newComponentArray[priceData[0].parent_array_key][priceData[0].child_array_key][priceData[0].nested_array_key]['CustomSize'],'','','height');
                    
                    maxWidth1 = dataRangeWidth.split('-')[1]
                    maxHeight1 = dataRangeHeight.split('-')[1]
                    minWidth1 = dataRangeWidth.split('-')[0]
                    minHeight1 = dataRangeHeight.split('-')[0]
                }
                else{
                    // if(const_var.crmSetting.is_Edit == true && priceData[0].entry_doorNewType == "Custom Size"){
                        showCustomSize = 'none'
                        maxWidth1 = 60;
                        maxHeight1 = 72;
                        minWidth1 = 24;
                        minHeight1 = 24;
                        /* ----manage dropdown of window frameout for "Tubular Building Ststems (TBS) (SE3-T1554) Start-----*/
                        if(params.m_s_n == 13 && priceData[0].parent_array_key === "Windows_Frameout"){
                            maxWidth1 = 96;
                            maxHeight1 = 120;
                            minWidth1 = 12;
                            minHeight1 = 12;
                        }
                        /* ----manage dropdown of window frameout for "Tubular Building Ststems (TBS) (SE3-T1554) End-----*/
                        if (priceData[0].nested_array_key.includes("Transom Window")) {
                            minHeight1 = 10;
                        }
                    // }
                    // else{
                    //     showCustomSize = 'hide'
                    // }
                }
            }
            else{
                if(showCustomSize == 'none'){
                    maxWidth1 = 60;
                    maxHeight1 = 72;
                    minWidth1 = 24;
                    minHeight1 = 24;
                    /* ----manage dropdown of window frameout for "Tubular Building Ststems (TBS) (SE3-T1554) Start-----*/
                    if(params.m_s_n == 13 && priceData[0].parent_array_key === "Windows_Frameout"){
                        maxWidth1 = 96;
                        maxHeight1 = 120;
                        minWidth1 = 12;
                        minHeight1 = 12;
                    }
                    /* ----manage dropdown of window frameout for "Tubular Building Ststems (TBS) (SE3-T1554) End-----*/
                    if (priceData[0].nested_array_key.includes("Transom Window")) {
                        minHeight1 = 10;
                    }
                }
            }
        } else{
            if(const_var.c_m_a[params.p_b_t].custom_size_status && priceData[0].parent_array_key === "Garage" && const_var.c_m_a[params.p_b_t].custom_size_status.show_garage_door != undefined){
                showCustomSize = const_var.c_m_a[params.p_b_t].custom_size_status.show_garage_door == true ? 'show' : const_var.c_m_a[params.p_b_t].custom_size_status.show_garage_door == false ? 'hide' : 'none'
            }
            if(const_var.c_m_a[params.p_b_t].custom_size_status && priceData[0].parent_array_key === "Garage_Frameout" && const_var.c_m_a[params.p_b_t].custom_size_status.show_garage_door_frameout != undefined){
                showCustomSize = const_var.c_m_a[params.p_b_t].custom_size_status.show_garage_door_frameout == true ? 'show' : const_var.c_m_a[params.p_b_t].custom_size_status.show_garage_door_frameout == false ? 'hide' : 'none'
            }
            if(showCustomSize == 'show' && (priceData[0].parent_array_key === "Garage" || priceData[0].parent_array_key==="Garage_Frameout") && const_var.c_m_a[params.p_b_t].custom_size_status && const_var.newComponentArray[priceData[0].parent_array_key][priceData[0].child_array_key][priceData[0].nested_array_key]['CustomSize'] /* && const_var.newComponentArray[priceData[0].parent_array_key][priceData[0].child_array_key][priceData[0].nested_array_key]['CustomSize'].length != 0 */){

                if(const_var.newComponentArray[priceData[0].parent_array_key][priceData[0].child_array_key][priceData[0].nested_array_key]['CustomSize'].length != 0){
                    // ################### code to manage custom size dropdown from api ###################
        
                    let dataRangeWidth = isCheckCustomSizeInRange(priceData[0].parent_array_key,const_var.newComponentArray[priceData[0].parent_array_key][priceData[0].child_array_key][priceData[0].nested_array_key]['CustomSize'],'','','width');
                    let dataRangeHeight = isCheckCustomSizeInRange(priceData[0].parent_array_key,const_var.newComponentArray[priceData[0].parent_array_key][priceData[0].child_array_key][priceData[0].nested_array_key]['CustomSize'],'','','height');
                    
                    maxWidth1 = dataRangeWidth.split('-')[1]
                    maxHeight1 = dataRangeHeight.split('-')[1]
                    minWidth1 = dataRangeWidth.split('-')[0]
                    minHeight1 = dataRangeHeight.split('-')[0]

                }
                else{
                    // if(const_var.crmSetting.is_Edit == true && priceData[0].entry_doorNewType == "Custom Size"){
                        showCustomSize = 'none'
                        maxWidth1 = (priceData[0].entry_location.includes('end')==true)?params.p_w-2:params.p_d-2;
                        maxHeight1 = (priceData[0].entry_location.includes('end')==true)?Math.ceil(params.p_h + ((params.p_w/2) * (params.p_r_p/12))):params.p_h ;
                        
                        if(const_var.a_p_d_a!=undefined && const_var.a_p_d_a.garage_custom_frameout!=undefined)
                        {
                        if(const_var.a_p_d_a.garage_custom_frameout.length>0)
                        {
                            if(const_var.a_p_d_a.garage_custom_frameout[0].is_checked==true && priceData[0].parent_array_key=="Garage_Frameout")
                            {
                                if(const_var.editAPIDataByResponse.data==undefined)
                                {
                                    maxWidth1 = (priceData[0].entry_location.includes('end')==true)? parseInt(const_var.a_p_d_a.garage_custom_frameout[0].end):parseInt(const_var.a_p_d_a.garage_custom_frameout[0].side);
                                }else{

                                    if(const_var.editAPIDataByResponse.data!=undefined && const_var.editAPIDataByResponse.data.created_at>="2024-01-17")
                                    { 
                                        maxWidth1 = (priceData[0].entry_location.includes('end')==true)? parseInt(const_var.a_p_d_a.garage_custom_frameout[0].end):parseInt(const_var.a_p_d_a.garage_custom_frameout[0].side);
                                    }
                                }
                            }
                        }
                        }
                    // }
                    // else{
                    //     showCustomSize = 'hide'
                    // }
                }
   
            }
            else{
                maxWidth1 = (priceData[0].entry_location.includes('end')==true)?params.p_w-2:params.p_d-2;
                maxHeight1 = (priceData[0].entry_location.includes('end')==true)?Math.ceil(params.p_h + ((params.p_w/2) * (params.p_r_p/12))):params.p_h ;
                
                if(const_var.a_p_d_a!=undefined && const_var.a_p_d_a.garage_custom_frameout!=undefined)
                {
                if(const_var.a_p_d_a.garage_custom_frameout.length>0)
                {
                    if(const_var.a_p_d_a.garage_custom_frameout[0].is_checked==true && priceData[0].parent_array_key=="Garage_Frameout")
                    {
                        if(const_var.editAPIDataByResponse.data==undefined)
                        {
                            maxWidth1 = (priceData[0].entry_location.includes('end')==true)? parseInt(const_var.a_p_d_a.garage_custom_frameout[0].end):parseInt(const_var.a_p_d_a.garage_custom_frameout[0].side);
                        }else{

                            if(const_var.editAPIDataByResponse.data!=undefined && const_var.editAPIDataByResponse.data.created_at>="2024-01-17")
                            { 
                                maxWidth1 = (priceData[0].entry_location.includes('end')==true)? parseInt(const_var.a_p_d_a.garage_custom_frameout[0].end):parseInt(const_var.a_p_d_a.garage_custom_frameout[0].side);
                            }
                        }
                    }
                }
                }
            }
        }
    }
    let automaticOpener = DoorObjData?.addons?.find(item => item.addon_type == "automatic_openers");
    let automaticOpenerVisibility = automaticOpener ? automaticOpener.is_show: false;
    let isAutomaticOpenerDisable = automaticOpener ? automaticOpener.is_default : false;
    
    let headerSeal = DoorObjData?.addons?.find(item => item.addon_type == "header_seal");
    let headerSealVisibility = (const_var.post_data?.custom_building == 1 || headerSeal) ? headerSeal.is_show: false;
    let isHeaderSealDiable = headerSeal ? headerSeal.is_default : false;

    let chainhoist = DoorObjData?.addons?.find(item => item.addon_type == "chain_hoist");
    let chainHoistVisibility = (const_var.post_data?.custom_building == 1 || chainhoist) ? chainhoist.is_show: false;
    let isChainHoistDisable = chainhoist ? chainhoist.is_default : false;

    let certified = DoorObjData?.addons?.find(item => item.addon_type == "certified");
    let certifiedVisibility = (const_var.post_data?.custom_building == 1 || certified) ? certified.is_show: false;
    let isCertifiedDisable = certified ? certified.is_default : false;


    if (params.m_s_n == 3 || params.m_s_n == 9) {
      isAutomaticOpenerDisable = (DoorObjData.is_automatic_openers == 2 || priceData[0]?.entry_header_seal == true) ? true : false;
      isHeaderSealDiable = (DoorObjData.is_header_seal == 2 || priceData[0]?.entry_automatic_openers == true) ? true : false;

      if (priceData.length > 0 && priceData[0].entry_automatic_openers == true && priceData[0].entry_header_seal == true) {
         if (DoorObjData.is_automatic_openers != 2) isAutomaticOpenerDisable = false;
         if (DoorObjData.is_header_seal != 2) isHeaderSealDiable = false;
      }
    }
    let isHeaderSealPriceBoxDisable = false
    if(params.m_s_n == 87 && DoorObjData?.is_header_seal == 1){
        isHeaderSealDiable = true
        isHeaderSealPriceBoxDisable = true
    }

    if(priceData.length > 0 && priceData[0].entry_location.includes('end')==true)
    {
        wallCheckForEnd = true;
    }
    if(priceData.length > 0 && priceData[0].entry_location.includes('side')==true)
    {
        wallCheckForSide = true;
    }

      let isStyleFeature = false;
      
      let is_overhead_door = (priceData.length > 0 && (priceData[0].child_array_key == "overhead_door_door" || priceData[0].child_array_key == "panel_garage_door_door") && const_var.newComponentArray[priceData[0].parent_array_key][priceData[0].child_array_key][priceData[0].nested_array_key]['Size'][priceData[0].name]?.door_add_ons.length > 0)
      let overhead_addons, motorOption, insulatedOption, insulatedIsCost,addOnOption;




      if (is_overhead_door) {
         overhead_addons = const_var.newComponentArray[priceData[0].parent_array_key][priceData[0].child_array_key][priceData[0].nested_array_key]['Size'][priceData[0].name]?.door_add_ons;
         motorOption = overhead_addons.find((e) => e.door == "motor");
         insulatedOption = overhead_addons.find((e) => {
            if (e.door == "insulated") {
               // insulatedIsCost = e.is_cost
               return true;
            }
         });
         addOnOption = overhead_addons.find((e) => e.door == "add_on_options");
      }

    const onStart = () => { 
        setActiveDrags(prev => prev + 1);
    };

    const onStop = () => {
        setActiveDrags(prev => prev - 1);
    };

    const onControlledDrag = (e, position) => {  
        const {x, y} = position;
        setControlledPosition({x, y});
    };
    
    const dragHandlers = {onStart: onStart, onStop: onStop};
    const headerSealChainHoistAction = (value,type,uniqueId,certified,DoorObjData)=>{
        dispatch(actionCreator.headerSealChainHoistAction(value,type,uniqueId,certified,DoorObjData))
    }
    const changeComponent = (value,type,obj)=>
    {
        dispatch(actionCreator.changeComponent(value,type,obj))
    }
    const changeComponentSize = (size, doorUniqueId,obj,isJtrim, value) => {
        
        dispatch(actionCreator.changeComponentSize(size, doorUniqueId,obj,isJtrim, value))
        //dispatch(actionCreator.updateChangeSizeType(doorUniqueId, false));
       
        // const selectedDoor = const_var.newDoorsArray.filter((item) => item.uniqueId === doorUniqueId);
        // if (selectedDoor.length > 0 && size !== 'Custom Size') {
        //     const compType = selectedDoor[0].userData.compType;
        //     const compName = selectedDoor[0].userData.compName;
        //     const wallName = selectedDoor[0].userData.wallName;
        //     const width = (compType === 'garage_door' || compType === 'garage_door_frameout') ? parseFloat(size.split('x')[0]) : parseFloat(size.split('x')[0]) / 12;
        //     const height = (compType === 'garage_door' || compType === 'garage_door_frameout') ? parseFloat(size.split('x')[1]) : parseFloat(size.split('x')[1]) / 12;
        //     const positionX = selectedDoor[0].positionX;
        //     const positionY = (compType === "garage_door" || compType === "garage_door_frameout" || compType === "walkin" || compType === "walkin_frameout") ? height / 2 : selectedDoor[0].positionY
        //     const sideArray = const_var.newDoorsArray.filter((item) => item.uniqueId !== doorUniqueId && item.userData.wallName === wallName);

        //     dispatch(actionCreator.changeDoorWindowSize(compType, compName, width, height, wallName, positionX, positionY, sideArray, doorUniqueId))
        // }
    };
    
    const textfieldClick = () => {
        setIsTextField(true)
    }

    const textfieldBlur = (e) => {
        if (e.relatedTarget?.innerText === 'DONE') return
        setIsTextField(false);
    }
    
    const handleCloseforDoorWindows = () => {
        // dispatch(actionCreator.handleCloseforDoorWindows(doorUniqueId, findIndex, entryNoteDataValue));
        dispatch(actionCreator.handleCloseforDoorWindows(doorUniqueId, findIndex, ''));
        setIsTextField(false);
        setFirst(true)
    }

    const editComponentSize = () => {}

    let styleFeature = (
        <>
            
        </>
    )

    useEffect(() => {
        const windowInnerHeight = window.innerHeight;
        const windowInnerWidth = window.innerWidth;
        const DwEditBoxPos = document.querySelector('.door-window-drag-inner').getBoundingClientRect();

        if (const_var.showComponentEditBox) {
            if (windowInnerWidth >= 992) {
                if (DwEditBoxPos.height + 60 > windowInnerHeight) {
                    setControlledPosition({x: (windowInnerWidth - DwEditBoxPos.width) / 2, y: 60})
                } else {
                    setControlledPosition({x: (windowInnerWidth - DwEditBoxPos.width) / 2, y: (windowInnerHeight - DwEditBoxPos.height) / 2 - 30})
                }
            }
            setFirst(true)
        }else{
            setControlledPosition({x: windowInnerWidth - DwEditBoxPos.x , y: windowInnerHeight - DwEditBoxPos.y })
        }
    }, [const_var.showComponentEditBox]);


   const [first , setFirst] = useState(true)
    
    var settings = {
        dots: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: false,
        rows: 4,
    };
     // ######### SE3-I5606 : If custom size is selected we slides to initial slide in slider ###############
    useEffect(() => {
        if (priceData.length > 0 && priceData[0] != undefined && priceData[0]?.entry_doorNewType != undefined) {
            focus(0)
        }
    },[priceData.length > 0 && priceData[0]])
    const sliderRef = useRef(null);

    const focus = (index) => {
        if(sliderRef.current !== null){
            let use = parseInt(index/3)
            sliderRef.current.slickGoTo(use)
        }
    }

let overhead_door_name_arr = (priceData[0]?.component_name)?.replace("overhead_door_door_", "").split("_");
      let overhead_door_name = ''
      if(overhead_door_name_arr != undefined){
         overhead_door_name_arr = overhead_door_name_arr.map((name) => {
            return name[0]?.toUpperCase() + name.slice(1);
         })
         overhead_door_name = overhead_door_name_arr.join(" ");
      }

      // ###### Heritage case
      let heritageEditCase = const_var.crmSetting.is_Edit == true && params.m_s_n == 153 && const_var.editAPIDataByResponse != undefined && const_var.editAPIDataByResponse.data != undefined;

    let manufacturerDoorName = params.doorNames[params.m_s_n] || "Garage";
    let componentNames = ""
    if(priceData.length > 0 && priceData[0].parent_array_key == "Garage"){
        componentNames = "Garage Door" +' ('+ priceData[0].name + ")'" ;
    }else if(priceData.length > 0 && priceData[0].parent_array_key == "Walk"){
        componentNames = "Walk-in Door" +' ('+ priceData[0].name + ')"' ;
    }else if(priceData.length > 0 && priceData[0].parent_array_key == "Garage_Frameout"){
        componentNames = (manufacturerDoorName!='Frameout')?`${manufacturerDoorName} Frameout` +' ('+ priceData[0].name + ")'":`${manufacturerDoorName}` +' ('+ priceData[0].name + ")'" ;
    }else if(priceData.length > 0 && priceData[0].parent_array_key == "Walk_Frameout"){
        componentNames = "Walk-in Frameout" +' ('+ priceData[0].name + ')"' ;
    }else if(priceData.length > 0 && priceData[0].parent_array_key == "Windows_Frameout"){
        componentNames = "Window Frameout" +' ('+ priceData[0].name + ')"' ;
    }else {
        if(priceData.length > 0 && priceData[0].parent_array_key!=undefined ){
            componentNames = priceData[0].parent_array_key+' ('+ priceData[0].name + ')"' ;
        }
    } 

    /* ############### Entry points dropdown data ############### */
    const componentDropdownData = [];

    const_var.newComponentArray[priceData?.[0]?.parent_array_key] != undefined &&
    const_var.newComponentArray[priceData?.[0]?.parent_array_key].map((item, index) => {
        return (
            componentDropdownData.push({
                label: priceData?.[0]?.entry_type?.includes("frameout") ? `${item.alias_name} Frameout` : item.alias_name,
                value: item.alias_name,
                componentKey: item.type,
                data: item.sizes
            })
        )
    })
    /* ############### Entry points dropdown data ############### */

    let componentData;
    if  (priceData[0]){
        componentData = const_var.newComponentArray[priceData[0].parent_array_key].find(item => item.type == priceData[0].child_array_key && item.alias_name == priceData[0].nested_array_key);
        const customSizeData = componentData?.customSizes?.[0]?.custom_sizes?.[0];
        if (customSizeData) {
            // showCustomSize = 'show';
            // minWidth1 = customSizeData.min_width;
            // minHeight1 = customSizeData.min_height;
            maxWidth1 = customSizeData.max_width;
            maxHeight1 = customSizeData.max_height;
        } else {
            showCustomSize = 'hide';
        }
    }

    return (
        <div className={const_var.showComponentEditBox === true ?'dw-show-edit-box-wrapper ':'dw-show-edit-box-wrapper  d-none'}>
            <div onClick={() => {dispatch(actionCreator.hancleClickOutside())}} className='dweditbox-overlay'></div>
            <Draggable
                position={controlledPosition} 
                {...dragHandlers} 
                handle=".handle" 
                onDrag={onControlledDrag} 
                bounds="parent" 
                className={'card-box'}
            >
                <div className="door-window-drag-inner">
                    <div className="handle">
                        <span>
                            <i className='icon-drag-ico'></i>
                        </span>
                    </div>
                    {
                        (const_var.newDoorsArray.find(entry_points => entry_points.uniqueId == doorUniqueId)?.userData.compType === 'window' || const_var.newDoorsArray.find(entry_points => entry_points.uniqueId == doorUniqueId)?.userData.compType === 'walkin') &&
                        <div className='leg-info'>Placing components on the legs of the building's sides may incur additional charges.</div>
                    }
                    <div className="dw-show-edit-box-wrapper-top">
                        <div className='info-container'>
                            {(const_var.editComponentDimension != "CustomGarageSize" && priceData.length > 0 ) ?
                                <h5 class="section-title no-underline mb-0">
                                    {(params.m_s_n == 148 || params.m_s_n == 121 || params.m_s_n == 8 || params.m_s_n == 181) && componentNames?.toLowerCase().includes('garage frameout') ? componentNames.replace('Garage Frameout','Frameout') : componentNames}
                                    <span className="price-box-type-2 text-right d-none">
                                        <CurrencyFormat value = {priceData.length > 0 && priceData[0].entry_price !== undefined ? priceData[0].entry_price : 0} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                                    </span>
                                </h5>
                                :
                                <h5 class="section-title no-underline mb-0">{"Custom Size " + exactComName}
                                    <span className="price-box-type-2 text-right d-none">
                                        <CurrencyFormat value = {priceData.length > 0 && priceData[0].entry_price !== undefined ? priceData[0].entry_price : 0} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                                    </span>
                                </h5>
                            }
                            {((const_var.loginSession == true && const_var.post_data.building != undefined && priceData.length > 0 && const_var.editComponentDimension != "CustomGarageSize")) ?
                                <aside className="price-box">
                                    <EditPriceItem entry_pointsData={priceData[0]} uniqueId={priceData[0].uniqueId} componentPrice="true" jsonObj={priceData[0].entry_price} jsonObjKey="entry_price" />
                                </aside>
                                :
                                <>
                                    {(const_var.editComponentDimension != "CustomGarageSize" && priceData.length > 0 ) 
                                    ?
                                    <span className="price-box-type-2">
                                        {const_var.hide_price_calculation != 1 && const_var.loginSession == false && 
                                            <CurrencyFormat value = {priceData.length > 0 && priceData[0].entry_price !== undefined ? priceData[0].entry_price : 0} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                                        }
                                    </span>
                                    :
                                    <span className="price-box-type-2">
                                        {const_var.hide_price_calculation != 1 && const_var.loginSession == false && 
                                        <CurrencyFormat value = {priceData.length > 0 && priceData[0].entry_price !== undefined ? priceData[0].entry_price : 0} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                                        }
                                    </span>
                                    }
                                </>
                            }
                        </div>
                         {/* ############# Entry point change dropdown component ############# : Start : */}
                         {
                            priceData?.[0]?.parent_array_key !== "Garage_Frameout" && priceData?.[0]?.parent_array_key !== "Walk_Frameout" && priceData?.[0]?.parent_array_key !== "Windows_Frameout" && <div className='dropdown-container'>
                            <div className="floating-label-input">
                                <Select
                                    value={priceData?.[0]?.nested_array_key}
                                    options={componentDropdownData}
                                    onChange={(event) => {
                                        /** ######## Selected entry point data ######## */
                                        let filteredData = componentDropdownData?.find((item) => item.value === event.target.value);

                                        /** ######## Removed compoent data ######## */
                                        let deletedComponent = const_var.entry_points.filter(entry_points => entry_points.uniqueId == doorUniqueId);
                                        let componentWallName = deletedComponent?.[0]?.component_wall_name

                                        if(filteredData) {
                                            /** ######## First: removing a component from the wall ######## */
                                            dispatch(actionCreator.removeComponent(doorUniqueId,undefined,undefined, true));
                                            
                                            const CmpWidth = filteredData.data[0].fixed_sizes?.[0]?.width;
                                            const CmpHeight = filteredData.data[0].fixed_sizes?.[0]?.height;

                                            const width = (priceData?.[0]?.entry_type == "garage_door" || priceData?.[0]?.entry_type == "garage_door_frameout") ? parseInt(CmpWidth) : parseInt(CmpWidth) / 12;
                                            const height = (priceData?.[0]?.entry_type == "garage_door" || priceData?.[0]?.entry_type == "garage_door_frameout") ? parseInt(CmpHeight) : parseInt(CmpHeight ) / 12;
                                            
                                            let compType = priceData?.[0]?.entry_type;
                                            let compName= filteredData?.componentKey;
                                            let wallName = componentWallName || params.activeWall;
                                            let parentkey = priceData?.[0]?.parent_array_key;
                                            let childkey = filteredData?.componentKey;
                                            let nestedkey = filteredData?.value;
                                            
                                            /** ######## Second : checking if a component can be placed on a wall or not ######## */
                                            const validationVariable = addValidation({ compType, width, height, wallName, parentkey, childkey, nestedkey });
                                            
                                            /** ######## Third : Adding a component on the wall ######## */
                                            if(validationVariable.isAdd) {
                                                /** ######## For overhead_door_door and panel_garage_door_door ######## */
                                                let newDoorName = ''
                                                if(filteredData?.data[0]?.door_add_ons?.[0]?.category[0] != undefined) {
                                                        newDoorName = `${filteredData?.componentKey}_${(filteredData?.data[0]?.door_add_ons?.[0]?.category[0].category.split(' ').join('_')).toLowerCase()}`
                                                }

                                                /** ######## New door added on the wall */
                                                if(priceData?.[0]?.entry_type === "garage_door") {
                                                    dispatch(actionCreator.addDoorComponent(
                                                        priceData?.[0]?.entry_type,
                                                        (filteredData?.componentKey == "overhead_door_door" || filteredData?.componentKey == "panel_garage_door_door") ? newDoorName : filteredData?.componentKey,
                                                        wallName,
                                                        `${filteredData?.data[0].fixed_sizes?.[0]?.width}x${filteredData?.data[0].fixed_sizes?.[0]?.height}`,
                                                        priceData?.[0]?.parent_array_key,
                                                        filteredData?.componentKey,
                                                        event.target.value
                                                    ));
                                                } else {
                                                    dispatch(actionCreator.addDoorComponent(
                                                        priceData?.[0]?.entry_type,
                                                        filteredData?.componentKey,
                                                        wallName,
                                                       `${filteredData?.data[0].fixed_sizes?.[0]?.width}x${filteredData?.data[0].fixed_sizes?.[0]?.height}`,
                                                        priceData?.[0]?.parent_array_key,
                                                        filteredData?.componentKey,
                                                        event.target.value
                                                    ));
                                                }
                                            } else {
                                                if(deletedComponent && deletedComponent?.length > 0) {
                                                    /** ######## Show alert for no space available ######## */
                                                    dispatch(actionCreator.showDoorWindowsPrompt(compType, deletedComponent?.[0]?.child_array_key, width, height, wallName));
                                                    const_var.checkDoorIsadded = false;

                                                    /** ######## Previously removed door added again on the wall */
                                                    dispatch(actionCreator.addDoorComponent(
                                                        deletedComponent?.[0]?.entry_type, 
                                                        deletedComponent?.[0]?.child_array_key, 
                                                        deletedComponent?.[0]?.component_wall_name,
                                                        deletedComponent?.[0]?.name,
                                                        deletedComponent?.[0]?.parent_array_key,
                                                        deletedComponent?.[0]?.child_array_key,
                                                        deletedComponent?.[0]?.nested_array_key,
                                                        deletedComponent?.[0]?.entry_size
                                                    ));
                                                }
                                            }
                                        }     
                                    }}
                                />
                            </div>
                        </div>
                        }

                        {/* ############# Entry point change dropdown component ############# : End : */}

                        <div className='size-container'>
                          {(params.m_s_n == 3 || params.m_s_n == 9 || const_var.loginSession == false) ? <h6>Choose Default</h6> : <h6>Choose Default/Custom Sizes</h6> }
                            <div className='size-item-scroller'>
                                {(priceData.length > 0 && priceData[0].parent_array_key!="Garage_Frameout") && componentData  &&
                                    <>
                                        {
                                            componentData.sizes?.length > 12 &&
                                            <div className='slick-arrow-prev' onClick={() => { sliderRef?.current.slickPrev(); setFirst(false)}}>
                                                <i className='icon-double-arrow-ico'></i>
                                            </div>
                                        }
                                        <Slider ref={sliderRef}  {...settings}>
                                            {
                                                componentData.sizes?.map((item,index) => 
                                                    {

                                                        const key = `${item.fixed_sizes?.[0]?.width}x${item.fixed_sizes?.[0]?.height}`
                                                        if(priceData[0].name == key && first == true){
                                                            focus(index)
                                                        }
                                                        return (
                                                            key !== "Custom Size" && 
                                                            <div className='size-item'>
                                                                <Radio
                                                                    value={key}
                                                                    checked = {priceData[0].name == key}
                                                                    onClick={e => changeComponentSize(e.target.value, doorUniqueId,priceData[0])}
                                                                >
                                                                    {key}
                                                                </Radio>
                                                            </div>
                                                        )
                                                            
                                                    }
                                                )
                                            }
                                        </Slider>
                               
                                    </>
                                }
                            </div>
                            {(priceData.length>0 && priceData[0].parent_array_key=="Garage_Frameout" && priceData[0].entry_doorNewType==undefined)?

                                    <aside className="row d-flex mb-3">
                                            <div className="col-4 pr-2">
                                                <div className="floating-label-input floating-label-inside">
                                          <Select
                                             onChange={e => changeComponentSize(e.target.value+'x'+priceData[0].entry_dimension_height,doorUniqueId,priceData[0])}
                                             className="cpanelselect"
                                             // label="Width"
                                             value={priceData[0].entry_dimension_width}
                                             options={Object.entries(const_var.newComponentArray[priceData[0].parent_array_key][priceData[0].child_array_key][priceData[0].nested_array_key]['Width']).filter((e) => {
                                                let isSideWall = priceData[0].entry_location.includes("side");
                                                if (priceData[0].component_wall_name == "c_b_l_s_r_w" || priceData[0].component_wall_name == "c_b_r_s_l_w") isSideWall = true;
                                                // if ((isSideWall && params.m_s_n==122 && e[1] > 12)) {
                                                //    return false
                                                // }

                                                return true;
                                             }).map(([key, val],index) => {
                                               return (
                                                  {
                                                     "value": key,
                                                     "label": key
                                                  }
                                               )
                                          })}
                                          />
                                        </div>
                                        </div>
                                          <div className="col-4 pr-2">
                                                <div className="floating-label-input floating-label-inside">
                                          <Select
                                             onChange={e => changeComponentSize(priceData[0].entry_dimension_width+'x'+e.target.value,doorUniqueId,priceData[0])}
                                             className="cpanelselect"
                                             // label="Height"
                                             value={priceData[0].entry_dimension_height}
                                             options={Object.entries(const_var.newComponentArray[priceData[0].parent_array_key][priceData[0].child_array_key][priceData[0].nested_array_key]['Height']).map(([key, val],index) => {
                                                return (
                                                   {
                                                      "value": key,
                                                      "label": key
                                                   }
                                                )
                                             })}
                                          />
                                       </div>
                               </div>
                               </aside>
                             :null}
                            {
                                showCustomSize != 'hide' &&
                                <div className={`${(((params.m_s_n == 3 || params.m_s_n == 9) && (priceData.length > 0 && !priceData[0].entry_type?.includes('frameout')) || const_var.loginSession == false) && (priceData.length > 0 && priceData[0].entry_doorNewType!="Custom Size") || ((params.m_s_n == 153 && priceData.length > 0 && priceData[0].nested_array_key == "Roll-Up" && priceData[0].parent_array_key != "Garage_Frameout") || const_var.loginSession == false || heritageEditCase == true && (params.m_s_n == 153 && priceData.length > 0 && priceData[0].nested_array_key == "Roll-Up" && priceData[0].parent_array_key != "Garage_Frameout")) 
                                ||  (params.m_s_n == 77 && ((const_var.crmSetting.is_Edit == false && priceData.length > 0 && priceData[0].parent_array_key == "Garage" && priceData[0].nested_array_key == "Roll-Up") || (const_var.crmSetting.is_Edit == true && priceData.length > 0 && priceData[0].parent_array_key == "Garage" && priceData[0].nested_array_key == "Roll-Up" && priceData[0].entry_doorNewType != 'Custom Size'))) 
                                )? 'd-none' : ''} ${ const_var.isKLinkEnable && priceData && priceData[0] && priceData[0].entry_doorNewType == 'Custom Size' ? ' custom-size-disabled' : '' } `}>
                                    <div className='mb-1'>
                                        <Radio
                                            value={'Custom Size'}
                                            name={'surface'}
                                            checked={ priceData.length > 0 && priceData[0].entry_doorNewType!=undefined?true:false}
                                            onClick={(e) => changeComponentSize('Custom Size', doorUniqueId,priceData[0],'', e.target.checked)}
                                        >
                                            Customize Size
                                        </Radio>
                                    </div>
                                    {
                                        priceData.length>0 && priceData[0].entry_doorNewType === "Custom Size" &&
                                        <div>
                                            <aside className="row d-flex">
                                                <div className="col-4 pr-2">
                                                    <div className="floating-label-input floating-label-inside">
                                                        {(priceData[0].parent_array_key!="Garage" && priceData[0].parent_array_key!="Garage_Frameout") ?
                                                        <>
                                                            <Select
                                                                onChange={e => changeComponentSize(e.target.value + 'x' + priceData[0].name.split("x")[1], doorUniqueId,priceData[0])}
                                                                className="cpanelselect"
                                                                value={priceData[0].name.split("x")[0]}
                                                                options={Array.apply(null, { length: parseInt(maxWidth1) + 1 }).map(Number.call, Number).slice(parseInt(minWidth1)).map((val, index) => {
                                                                    return (
                                                                        {
                                                                        "value": val,
                                                                        "label": val
                                                                        }
                                                                    )
                                                                })}
                                                            />
                                                        </>
                                                            : 
                                                            <>
                                                            {
                                                                showCustomSize == 'show' ?
                                                                <>
                                                                    <Select
                                                                        onChange={e => changeComponentSize(e.target.value + 'x' + priceData[0].name.split("x")[1], doorUniqueId,priceData[0])}
                                                                        className="cpanelselect"
                                                                        value={priceData[0].name.split("x")[0]}
                                                                        options={Array.apply(null, { length: parseInt(maxWidth1) + 1 }).map(Number.call, Number).slice(parseInt(minWidth1)).map((val, index) => {
                                                                            return (
                                                                                {
                                                                                "value": val,
                                                                                "label": val
                                                                                }
                                                                            )
                                                                        })}
                                                                    />
                                                                </>
                                                                :
                                                                <>
                                                                    <Select
                                                                        onChange={e => changeComponentSize(e.target.value + 'x' + priceData[0].name.split("x")[1], doorUniqueId,priceData[0])}
                                                                        className="cpanelselect"
                                                                        value={priceData[0].name.split("x")[0]}
                                                                        options={Array.apply(null, { length: priceData[0].entry_location.includes("side") && 
                                                                            params.m_s_n==122 &&  
                                                                            priceData[0].parent_array_key=="Garage_Frameout" ? "13": maxWidth1 + 1 }).map(Number.call, Number).slice(5).map((val, index) => {
                                                                            return (
                                                                                {
                                                                                "value": val,
                                                                                "label": val
                                                                                }
                                                                            )
                                                                        })}
                                                                    />
                                                                </>
                                                            }
                                                            </>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="col-4 pl-2">
                                                    <div className="floating-label-input floating-label-inside">
                                                        {(priceData[0].parent_array_key!="Garage" && priceData[0].parent_array_key!="Garage_Frameout") ?
                                                            <Select
                                                                onChange={e => changeComponentSize(priceData[0].name.split("x")[0] + 'x' + e.target.value, doorUniqueId,priceData[0])}
                                                                className="cpanelselect"
                                                                value={priceData[0].name.split("x")[1]}
                                                                options={Array.apply(null, { length: parseInt(maxHeight1) + 1 }).map(Number.call, Number).slice(parseInt(minHeight1)).map((val, index) => {
                                                                    return (
                                                                        {
                                                                        "value": val,
                                                                        "label": val
                                                                        }
                                                                    )
                                                                })}
                                                            />
                                                            :
                                                            <>
                                                                {
                                                                    showCustomSize == 'show' ?
                                                                    <Select
                                                                        onChange={e => changeComponentSize(priceData[0].name.split("x")[0] + 'x' + e.target.value, doorUniqueId,priceData[0])}
                                                                        className="cpanelselect"
                                                                        value={priceData[0].name.split("x")[1]}
                                                                        options={Array.apply(null, { length: parseInt(maxHeight1) + 1 }).map(Number.call, Number).slice(parseInt(minHeight1)).map((val, index) => {
                                                                            return (
                                                                                {
                                                                                "value": val,
                                                                                "label": val
                                                                                }
                                                                            )
                                                                        })}
                                                                    />
                                                                    :
                                                                    <Select
                                                                        onChange={e => changeComponentSize(priceData[0].name.split("x")[0] + 'x' + e.target.value, doorUniqueId,priceData[0])}
                                                                        className="cpanelselect"
                                                                        value={priceData[0].name.split("x")[1]}
                                                                        options={Array.apply(null, { length: parseInt(maxHeight1) + 1 }).map(Number.call, Number).slice(5).map((val, index) => {
                                                                            return (
                                                                                {
                                                                                "value": val,
                                                                                "label": val
                                                                                }
                                                                            )
                                                                        })}
                                                                    />
                                                                }
                                                            </>
                                                        }
                                                    </div>
                                                </div>
                                            </aside>
                                            <aside className="price-box d-none">
                                                {((const_var.loginSession == true && const_var.post_data.building != undefined && priceData.length > 0)) ?
                                                    <EditPriceItem entry_pointsData={priceData[0]} uniqueId={priceData[0].uniqueId} componentPrice="true" jsonObj={priceData[0].entry_price} jsonObjKey="entry_price" />
                                                    : null
                                                }
                                            </aside>
                                        </div>
                                    }
                                    </div> 
                            }
                            {(is_overhead_door && const_var.newComponentArray?.[priceData[0].parent_array_key][priceData[0].child_array_key][priceData[0].nested_array_key]['Size'][priceData[0].name]?.door_add_ons[0].category.length>1)?
                            
                                 <div className="form-group">
                                    <label className="control-label">Type</label>
                                       
                                          <div className="floating-label-input">
                                             <Select
                                                onChange={e => changeComponent(e.target.value,doorUniqueId,priceData[0])}
                                                value={overhead_door_name}
                                                options={const_var.newComponentArray[priceData[0].parent_array_key][priceData[0].child_array_key][priceData[0].nested_array_key]['Size'][priceData[0].name]?.door_add_ons[0].category.map((key,index) => {
                                                   return (
                                                      {
                                                         "value": key.category,
                                                         "label": key.category
                                                      }
                                                   )
                                                })}
                                             />
                                          </div>
                                 
                                 </div>
                             : null}
                              
                            

                        </div>
                        
                       
                        <div className='style-features-container'>
                            {priceData.length>0 && priceData[0].entry_doorNewType != "Custom Size" && (priceData[0].parent_array_key=="Garage" || priceData[0].parent_array_key=="Garage_Frameout") &&
                            <>
                            <h6>Style & Features</h6>
                            <div className="form-group">
                                {(const_var.loginSession == false && priceData.length > 0 && priceData[0].entry_trim_kit_price!=undefined && ((DoorObjData["dutch_cost"] != undefined && DoorObjData["dutch_cost"] != 0)||(DoorObjData["45_degree_angle"] != undefined && ((const_var.post_data?.custom_building == 1 && priceData[0].entry_is_trim_kit!=false) || DoorObjData["45_degree_angle"] != 0)))) ?
                                  <div className={priceData[0].nested_array_key=="Sectional"?"d-none check-group":"check-group"}>
                                        
                                            <Checkbox
                                                className="secondary"
                                                ripple="RipplePropF"
                                                label="45 degree angle"
                                                checked={(priceData[0].entry_trim_kit==undefined)?params.trimkit:priceData[0].entry_trim_kit}
                                                onChange={e =>
                                                    changeComponentSize(e.target.value,doorUniqueId,priceData[0],'trim',e.target.checked)} 
                                            />
                                            {((const_var.loginSession == true && const_var.post_data.building != undefined && priceData.length > 0 && priceData[0].entry_trim_kit == true)) ?
                                                <aside className="price-box price-box-sm">
                                                    <EditPriceItem uniqueId={priceData[0].uniqueId} componentPrice="true" jsonObj={priceData[0].entry_trim_kit_price} jsonObjKey="entry_trim_kit_price" />
                                                </aside>
                                                :
                                                <div className="price-box-type-2 text-right">
                                                    {const_var.hide_price_calculation != 1 && const_var.loginSession == false && 
                                                    
                                                        <CurrencyFormat value = {(params.trimkit && priceData.length > 0 && (priceData[0].entry_trim_kit_price != undefined || priceData[0].entry_trim_kit_price != null)) ? priceData[0].entry_trim_kit_price : 0} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                                                    }
                                                </div>
                                            }
                                    </div>
                                    : null
                                }
                                {(priceData.length > 0 && priceData[0].entry_trim_kit_price!=undefined && const_var.loginSession == true && priceData[0].entry_is_trim_kit!=false) ?
                                    <div className={priceData[0].nested_array_key=="Sectional"?"d-none check-group":"check-group"}>
                                        
                                            <Checkbox
                                                // className={const_var.checkDoorIsadded /* ||checkDoorIsaddedChk */ ? 'secondary no-cursor' : 'secondary'}
                                                className = 'secondary'
                                                ripple="RipplePropF"
                                                label="45 degree angle"
                                                checked={(priceData[0].entry_trim_kit==undefined)?params.trimkit:priceData[0].entry_trim_kit}
                                                onChange={e =>
                                                    changeComponentSize(e.target.value,doorUniqueId,priceData[0],'trim',e.target.checked)} 
                                            />
                                            {((const_var.loginSession == true && const_var.post_data.building != undefined && priceData.length > 0 && priceData[0].entry_trim_kit == true)) ?
                                                <aside className="price-box price-box-sm">
                                                    <EditPriceItem uniqueId={priceData[0].uniqueId} componentPrice="true" jsonObj={priceData[0].entry_trim_kit_price} jsonObjKey="entry_trim_kit_price" />
                                                </aside>
                                                :
                                                <div className="price-box-type-2 text-right">
                                                    {const_var.hide_price_calculation != 1 && const_var.loginSession == false && 
                                                        <CurrencyFormat value = {(priceData.length > 0 && priceData[0].entry_trim_kit == true && (priceData[0].entry_trim_kit_price != undefined || priceData[0].entry_trim_kit_price != null)) ? priceData[0].entry_trim_kit_price : 0} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                                                    }
                                                </div>
                                            }
                                        
                                    </div>
                                    : null
                                }
                                {headerSealVisibility?
                                    <div className="check-group">
                                            <Checkbox
                                                className="secondary"
                                                ripple="RipplePropF"
                                                label={params.m_s_n == 153 ? "Threshold Seal" : "Header Seal"}
                                                disabled={isHeaderSealDiable}
                                                checked={isHeaderSealDiable ? true : (priceData[0].entry_header_seal!=undefined)?priceData[0].entry_header_seal:params.header_seal}
                                                onChange={e =>
                                                    headerSealChainHoistAction(e.target.value, 'headerSeal', doorUniqueId,DoorObjData)} 
                                            />
                                            {((const_var.loginSession == true && const_var.post_data.building != undefined && priceData.length > 0 && priceData[0].entry_header_seal == true && DoorObjData.is_header_seal != 2)) ?
                                                <span className={"price-box price-box-sm" + (priceData[0].entry_header_seal && isHeaderSealPriceBoxDisable ? ' disabled' : '')}>
                                                    <EditPriceItem uniqueId={priceData[0].uniqueId} componentPrice="true" jsonObj={priceData[0].entry_header_seal_price} jsonObjKey="entry_header_seal_price" />
                                                </span>
                                                :
                                                <div className={"price-box-type-2 d-inline-flex ml-2" + (priceData[0].entry_header_seal && isHeaderSealPriceBoxDisable ? ' disabled' : '')}>
                                                    {const_var.hide_price_calculation != 1 && const_var.loginSession == false && 
                                                    <CurrencyFormat value = {priceData.length > 0 && priceData[0].entry_header_seal && priceData[0].entry_header_seal_price !== undefined ? priceData[0].entry_header_seal_price : 0} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                                                    }
                                                </div>
                                            }
                                     </div>
                                    : null
                                }
                                 { chainHoistVisibility ?
                                    <div className="check-group">
                                           <Checkbox
                                                className="secondary"
                                                ripple="RipplePropF"
                                                label="Chain-Hoist"
                                                disabled={isChainHoistDisable}
                                                checked={isChainHoistDisable ? true : (priceData[0].entry_chain_hoist!=undefined)?priceData[0].entry_chain_hoist:params.chain_hoist}
                                                onChange={e =>
                                                    headerSealChainHoistAction(e.target.value, 'chainHoist', doorUniqueId,DoorObjData)} 
                                            />
                                            {((const_var.loginSession == true && const_var.post_data.building != undefined && priceData.length > 0 && priceData[0].entry_chain_hoist== true && DoorObjData.is_chain_hoist != 2)) ?
                                                <aside className="price-box price-box-sm">
                                                    <EditPriceItem uniqueId={priceData[0].uniqueId} componentPrice="true" jsonObj={priceData[0].entry_chain_hoist_price} jsonObjKey="entry_chain_hoist_price" />
                                                </aside>
                                                : 
                                                <div className="price-box-type-2 d-inline-flex ml-2">
                                                {const_var.hide_price_calculation != 1 && const_var.loginSession == false && 
                                                    <CurrencyFormat value = {params.chain_hoist && priceData.length > 0 && priceData[0].entry_chain_hoist_price !== undefined ? priceData[0].entry_chain_hoist_price : 0} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                                                }  
                                                </div>      
                                            }
                                     </div>
                                    : null
                                }
                                {certifiedVisibility ?
                                        <div className="check-group">
                                            <Checkbox
                                                className="secondary"
                                                ripple="RipplePropF"
                                                label="Certified Door"
                                                disabled={isCertifiedDisable}
                                                checked={isCertifiedDisable ? true : (priceData[0].entry_certified!=undefined)?priceData[0].entry_certified :params.certified_door}
                                                onChange={e =>
                                                    headerSealChainHoistAction(e.target.value, 'certified_door', doorUniqueId,params.certified_door,DoorObjData)} 
                                            />
                                            <div className="price-box-type-2 d-inline-flex ml-2">
                                                {/*<CurrencyFormat value = 1595 displayType={'text'} thousandSeparator={true} prefix={'$'} />*/}
                                            </div>
                                        </div>
                                    : null
                                }
        {motorOption ? (<div>  
               <div className="check-group">
                  <Checkbox
                     className="secondary"
                     ripple="RipplePropF"
                     label="Motors"
                     checked={priceData[0].entry_motor}
                     onChange={ e => {
                           headerSealChainHoistAction(e.target.checked, "motorOption", doorUniqueId,params.motor,DoorObjData)
                        }
                     }
                  />
                    
         </div>  
      {priceData[0].entry_motor?
         motorOption.category.map((citem, cindex) => {
            return ((priceData.length > 0 && citem.is_cost!=undefined && (const_var.post_data?.custom_building == 1 || citem.cost != 0 || citem.is_cost == 2)) && <div key={cindex} className="check-group">
               {isStyleFeature = true}
                        <Radio
                           // className="secondary"
                           // ripple="RipplePropF"
                           label={citem.category}
                           value={citem.category}
                           checked={citem.category == priceData[0].entry_motor_name}
                        
                           onChange={e =>
                              headerSealChainHoistAction({name: citem.category, price: citem.cost}, motorOption.door, doorUniqueId,params.motor,DoorObjData)
                           } 
                        />
                        
                    
                  
               
                  {((const_var.loginSession == true && const_var.post_data.building != undefined && priceData.length > 0 && citem.category == priceData[0].entry_motor_name)) ?
                     <aside className="price-box price-box-sm">
                        <EditPriceItem uniqueId={priceData[0].uniqueId} componentPrice="true" jsonObj={priceData[0].entry_motor_price} jsonObjKey="entry_motor_price" />
                     </aside>
                     :
                  <div className="price-box-type-2 d-inline-flex ml-2">
                     {const_var.hide_price_calculation != 1 && const_var.loginSession == false && 
                        <CurrencyFormat value = {citem.category == priceData[0].entry_motor_name ? priceData[0].entry_motor_price: 0} displayType={'text'} thousandSeparator={true} prefix={citem.cost_type} />
                        }
                  </div>
                  }
             </div>)
         }): null
      } 
      </div>)
       : null
    }
    {insulatedOption ?
       insulatedOption.category.map((item, index) => {
           return ((priceData.length > 0 && item.is_cost!=undefined && (const_var.post_data?.custom_building == 1 || item.cost != 0 || item.is_cost == 2)) && <div className="check-group">
             {isStyleFeature = true}
              
                    <Checkbox
                         className="secondary"
                         ripple="RipplePropF"
                         label={item.category}
                         value={item.cost}
                         disabled={(item.is_cost == 2) ? true : false}
                         checked={(item.is_cost == 2) ? true : (priceData[0].entry_insulated!=undefined)?priceData[0].entry_insulated:params.insulated}                    
                         onChange={e =>
                            headerSealChainHoistAction(Number(e.target.value), insulatedOption.door, doorUniqueId,params.insulated,DoorObjData)
                         } 
                      />
                        
                   
           </div>)
          })
           : null
        }

    {addOnOption ?
       addOnOption.category.map((item, index) => {
           return ((priceData.length > 0 && item.is_cost!=undefined && (const_var.post_data?.custom_building == 1 || item.is_cost == 1 || item.is_cost == 2)) && <div className="check-group">
                
                      <Checkbox
                         className="secondary"
                         ripple="RipplePropF"
                         label={item.category}
                         value= {priceData[0]["entry_" + item.category.replace(/\s/g, '_').toLowerCase() + "_" + addOnOption.door + "_price"]}
                         disabled={(item.is_cost == 2) ||((item.category == "Frame Out") && priceData[0]["entry_" + item.category.replace(/\s/g, '_').toLowerCase() + "_" + addOnOption.door]) ? true : false}
                         checked={(item.is_cost == 2) ? true : (priceData[0]["entry_" + item.category.replace(/\s/g, '_').toLowerCase() + "_" + addOnOption.door]!=undefined)?priceData[0]["entry_" + item.category.replace(/\s/g, '_').toLowerCase() + "_" + addOnOption.door]:params[item.category.replace(/\s/g, '_').toLowerCase() + "_" + addOnOption.door]}                                        
                         onChange={e =>
                            headerSealChainHoistAction(item.cost, item.category.replace(/\s/g, '_').toLowerCase() + "_" + addOnOption.door, doorUniqueId,priceData[0]["entry_" + item.category.replace(/\s/g, '_').toLowerCase() + "_" + addOnOption.door],DoorObjData)
                         } 
                      />
                        
                    
                
              
                 {item.category != "Frame Out" && (((const_var.loginSession == true && const_var.post_data.building != undefined && priceData.length > 0 && priceData[0]["entry_" + item.category.replace(/\s/g, '_').toLowerCase() + "_" + addOnOption.door]/* && priceData[0].entry_header_seal == true && DoorObjData.is_header_seal != 2 */)) ?
                    <aside className="price-box price-box-sm">
                       <EditPriceItem uniqueId={priceData[0].uniqueId} componentPrice="true" jsonObj={priceData[0]["entry_" + item.category.replace(/\s/g, '_').toLowerCase() + "_" + addOnOption.door + "_price"]} jsonObjKey={"entry_" + item.category.replace(/\s/g, '_').toLowerCase() + "_" + addOnOption.door + "_price"} />
                    </aside>
                    :
                 <div className="price-box-type-2 d-inline-flex ml-2">
                     {const_var.hide_price_calculation != 1 && const_var.loginSession == false && 
                      <CurrencyFormat value = {priceData[0]["entry_" + item.category.replace(/\s/g, '_').toLowerCase() + "_" + addOnOption.door]? priceData[0]["entry_" + item.category.replace(/\s/g, '_').toLowerCase() + "_" + addOnOption.door + "_price"]: 0} displayType={'text'} thousandSeparator={true} prefix={item.cost_type} />
                      }
                 </div>)
                 }
                 
           </div>)
          })
           : null
        }
                                {automaticOpenerVisibility?
                                    <div className="mb-1">
                                        <div className="check-group">
                                            <Checkbox
                                                className="secondary"
                                                ripple="RipplePropF"
                                                label="Automatic Opener"
                                                disabled={isAutomaticOpenerDisable}
                                                checked={isAutomaticOpenerDisable ? true : (priceData[0].entry_automatic_openers!=undefined)?priceData[0].entry_automatic_openers:params.automatic_openers}
                                                onChange={e =>
                                                    headerSealChainHoistAction(e.target.value, 'automatic_openers', doorUniqueId,DoorObjData)} 
                                            />
                                            {((const_var.loginSession == true && const_var.post_data.building != undefined && priceData.length > 0 && priceData[0].entry_automatic_openers == true && DoorObjData.is_automatic_openers != 2)) ?
                                                <aside className="price-box price-box-sm">
                                                    <EditPriceItem uniqueId={priceData[0].uniqueId} componentPrice="true" jsonObj={priceData[0].entry_automatic_openers_price} jsonObjKey="entry_automatic_openers_price" />
                                                </aside>
                                                : 
                                                <div className="price-box-type-2 d-inline-flex ml-2">
                                                    {const_var.hide_price_calculation != 1 && const_var.loginSession == false && 
                                                        <CurrencyFormat value = {params.automatic_openers && priceData.length > 0 && priceData[0].entry_automatic_openers_price !== undefined ? priceData[0].entry_automatic_openers_price : 0} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                                                    }
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    : null
                                }
                                {(priceData.length > 0 && priceData[0].installation_is_end_wall!=undefined  && (priceData[0].installation_is_end_wall !='') && wallCheckForEnd==true)?
                                    <div className="mb-1">
                                        <div className={(priceData[0].installation_is_end_wall == "included")?"check-group":"check-group"}>
                                            <Checkbox
                                                className="secondary"
                                                ripple="RipplePropF"
                                                label={(priceData[0].installation_is_end_wall == "included")?"End Installation Fee (Included)":"End Installation Fee"}
                                                disabled={(priceData[0].installation_is_end_wall == "included") ? true : false}
                                                checked={(priceData[0].installation_is_end_wall != 'no') ? true : false}
                                                onChange={e =>
                                                    headerSealChainHoistAction(e.target.value, 'installation_is_end_wall', doorUniqueId,DoorObjData)} 
                                            />
                                            {((const_var.loginSession == true && const_var.post_data.building != undefined && priceData.length > 0 && priceData[0].installation_is_end_wall != "no" && DoorObjData.installation_is_end_wall != "included")) ?
                                                <aside className="price-box price-box-sm">
                                                    <EditPriceItem uniqueId={priceData[0].uniqueId} componentPrice="true" jsonObj={priceData[0].installation_end_wall_fee} jsonObjKey="installation_end_wall_fee" />
                                                </aside>
                                                : 
                                                <div className="price-box-type-2 d-inline-flex ml-2">
                                                    {const_var.hide_price_calculation != 1 && const_var.loginSession == false && 
                                                        <CurrencyFormat value = {priceData.length > 0 && priceData[0].installation_end_wall_fee !== undefined ? priceData[0].installation_end_wall_fee : 0} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                                                    }
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    : null
                                }
                                {(priceData.length > 0 && priceData[0].installation_is_side_wall!=undefined  && (priceData[0].installation_is_side_wall !='') && wallCheckForSide==true)?
                                    <div className="mb-1">
                                        <div className={(priceData[0].installation_is_side_wall == "included")?"check-group":"check-group"}>
                                            <Checkbox
                                                className="secondary"
                                                ripple="RipplePropF"
                                                label={(priceData[0].installation_is_side_wall == "included")?"Side Installation Fee (Included)":"Side Installation Fee"}
                                                disabled={(priceData[0].installation_is_side_wall == "included") ? true : false}
                                                checked={(priceData[0].installation_is_side_wall != 'no') ? true : false}
                                                onChange={e =>
                                                    headerSealChainHoistAction(e.target.value, 'installation_is_side_wall', doorUniqueId,DoorObjData)} 
                                            />
                                            {((const_var.loginSession == true && const_var.post_data.building != undefined && priceData.length > 0 && priceData[0].installation_is_side_wall  != "no" && DoorObjData.installation_is_side_wall != "included")) ?
                                                <aside className="price-box price-box-sm">
                                                    <EditPriceItem uniqueId={priceData[0].uniqueId} componentPrice="true" jsonObj={priceData[0].installation_side_wall_fee} jsonObjKey="installation_side_wall_fee" />
                                                </aside>
                                                : 
                                                <div className="price-box-type-2 d-inline-flex ml-2">
                                                    {const_var.hide_price_calculation != 1 && const_var.loginSession == false && 
                                                        <CurrencyFormat value = {priceData.length > 0 && priceData[0].installation_side_wall_fee !== undefined ? priceData[0].installation_side_wall_fee : 0} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                                                    }
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    : null
                                }
                            </div>
                            </>
                            }
                            {
                                params.m_s_n == 9 && priceData?.length>0 && priceData[0].parent_array_key=="Walk" && (priceData[0].nested_array_key=="9 Lite" || priceData[0].nested_array_key=="6-Panel Metal Door") &&
                                <>
                                    <h6>Style & Features</h6>
                                    <div className="form-group">
                                        <div className={"check-group"}>
                                            <Checkbox
                                                className="secondary"
                                                ripple="RipplePropF"
                                                label="threshold"
                                                checked={(priceData[0].threshold==undefined)?params.threshold:priceData[0].threshold}
                                                onChange={e =>
                                                    headerSealChainHoistAction(e.target.value, 'threshold', doorUniqueId,DoorObjData)} 
                                            />
                                            {((const_var.loginSession == true && const_var.post_data.building != undefined && priceData.length > 0 && priceData[0].threshold == true)) ?
                                                <aside className="price-box price-box-sm">
                                                    <EditPriceItem uniqueId={priceData[0].uniqueId} componentPrice="true" jsonObj={priceData[0].threshold_price} jsonObjKey="threshold_price" />
                                                </aside>
                                                :
                                                <div className="price-box-type-2 text-right">
                                                    {const_var.hide_price_calculation != 1 && const_var.loginSession == false && 
                                                        <CurrencyFormat value = {(priceData.length > 0 && priceData[0].threshold == true && (priceData[0].threshold_price != undefined || priceData[0].threshold_price != null)) ? priceData[0].threshold_price : 0} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                                                    }
                                                </div>
                                            }
                                        </div>                                        
                                    </div>
                                </>
                            }
                        </div>
                        {(priceData.length>0 && priceData[0].entry_garageDoor_color_price!=undefined && doorColorData!=undefined) &&
                            <div className='colors-container'>
                                {
                                    priceData[0].parent_array_key === 'Garage' &&  params.m_s_n == '44' &&  
                                    <div className='door-note-container'>
                                        
                                        <span className='icon-info-ico'></span>
                                        <span className='note-text'>
                                            The color will not match the siding.
                                        </span>
                                    </div>
                                }
                                <div className='color-header'>
                                    <h6>Color : </h6>
                                    <span className="color-box-name">{(priceData.length>0 && priceData[0].entry_garageDoor_color_Obj!=undefined)?priceData[0].entry_garageDoor_color_Obj.name:''}</span>
                                    <aside className="price-box price-box-sm">
                                        {((const_var.loginSession == true &&const_var.post_data.building != undefined && priceData.length > 0 )) ?
                                            <EditPriceItem is_disabled="false" uniqueId={priceData[0].uniqueId} componentPrice="true" jsonObj={(const_var.post_data.building != undefined) ? priceData[0].entry_garageDoor_color_price : 0} jsonObjKey="entry_garageDoor_color_price" />
                                            : <div className="price-box-type-2 d-inline-flex ml-2">
                                                    {const_var.hide_price_calculation != 1 && const_var.loginSession == false && 
                                                        <CurrencyFormat value = {priceData.length > 0 && priceData[0].entry_garageDoor_color_price !== undefined ? priceData[0].entry_garageDoor_color_price : 0} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                                                    }
                                                </div>
                                                    
                                        }
                                    </aside>
                                </div>

                                <div className="color-group">
                                    {
                                        const_var.garageDoorColor.map((val, index) => {
                                            return (
                                                <div className='color-item'>
                                                    <label key={index} id={"color" + index} className={priceData[0].garage_door_color == val.hex_value.replace("#", "0x") ? "color-switch active " : "color-switch "} style={{ background: val.hex_value }} onClick={() => {}}>
                                                        <input type="radio" name="options" onClick={(e)=>headerSealChainHoistAction(val, 'door_color_price', doorUniqueId,DoorObjData)} value={val.hex_value} id={"doorColor" + index} />
                                                    </label>
                                                </div>
                                            )
                                        })
                                    }
                               </div>
                            </div>
                        }

                        <div className="note-container">
                            <div className="floating-label-input remove-helper-line w-full mt-3">
                                <TextField
                                    defaultValue={EntrynotesData}
                                    value={EntrynotesData}
                                    inputRef={(input) => {
                                        if(input != null) {
                                            input.style.padding = '12px 12px';
                                        }
                                    }}
                                    textarea
                                    fullwidth
                                    rows={isTextField ? 5 : 1}
                                    placeholder= {`    Write Additional Note here...`}
                                    maxLength={500}
                                    onChange={e => headerSealChainHoistAction(e.target.value, 'extra_notes', doorUniqueId,DoorObjData)}
                                    characterCount
                                    helpText={{
                                        persistent: true,
                                    }}
                                    onFocus={textfieldClick}
                                    onBlur={textfieldBlur}
                                />
                                {
                                    !isTextField && EntrynotesData == "" && 
                                    <span className='placeholder-icon'>
                                        <i className='icon-edit-ico'></i>
                                    </span>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="dw-show-edit-box-bottom">
                        <button onClick={handleCloseforDoorWindows} className="btn btn-primary btn-xs barlow-semibold text-uppercase">Done</button>
                    </div>
                </div>
            </Draggable>
        </div>
    )
}

export default DoorWindowEditBox